export class API_ENDPOINT_KEYS {
  static readonly getFormConfig = 'getFormConfig';
  static readonly getIntegrityOfficerConfigAndResponse = 'getIntegrityOfficerConfigAndResponse';
  static readonly getReferenceDataConfigAndResponse = 'getReferenceDataConfigAndResponse';
  static readonly getCoiFormConfigAndResponse = 'getCoiFormConfigAndResponse';
  static readonly getCoiFormConfigAndResponseReadOnly = 'getCoiFormConfigAndResponseReadOnly';
  static readonly getCoiFormConfigAndResponseExternal = 'getCoiFormConfigAndResponseExternal';
  static readonly getCoiFormConfigAndResponseExternalReadOnly = 'getCoiFormConfigAndResponseExternalReadOnly';
  static readonly getCoiFormConfigWithEmptyResponse = 'getCoiFormConfigWithEmptyResponse';
  static readonly getApproverCoiFormConfigAndResponse = 'getApproverCoiFormConfigAndResponse';
  static readonly getApproverCoiFormConfigAndResponseReadOnly = 'getApproverCoiFormConfigAndResponseReadOnly';
  static readonly getDopiFormConfigWithEmptyResponse = 'getDopiFormConfigWithEmptyResponse';
  static readonly getDopiFormConfigAndResponseReadOnly = 'getDopiFormConfigAndResponseReadOnly';
  static readonly getDopiFormConfigAndResponse = 'getDopiFormConfigAndResponse';
  static readonly getDopiFormConfigAndResponseExternal = 'getDopiFormConfigAndResponseExternal';
  static readonly getDopiFormConfigAndResponseExternalReadOnly = 'getDopiFormConfigAndResponseExternalReadOnly';
  static readonly getApproverDopiFormConfigAndResponse = 'getApproverDopiFormConfigAndResponse';
  static readonly getApproverDopiFormConfigAndResponseReadOnly = 'getApproverDopiFormConfigAndResponseReadOnly';
  static readonly getGbhFormConfigWithEmptyResponse = 'getGbhFormConfigWithEmptyResponse';
  static readonly getGbhFormConfigAndResponseReadOnly = 'getGbhFormConfigAndResponseReadOnly';
  static readonly getGbhFormConfigAndResponse = 'getGbhFormConfigAndResponse';
  static readonly getApproverGbhFormConfigAndResponse = 'getApproverGbhFormConfigAndResponse';
  static readonly getApproverGbhFormConfigAndResponseReadOnly = 'getApproverGbhFormConfigAndResponseReadOnly';
};

export class API_ENDPOINTS {
  static readonly authentication = {
    signIn: '/SignIn'
  } as const;

  static readonly setting = {
    getStaticPage: 'Setting/GetStaticPage'
  } as const;

  static readonly configuration = {
    default: 'FormConfiguration/GetConfiguration'
  } as const;

  static readonly address = {
    search: 'Address/Search',
    lga: 'Address/Lga'
  } as const;

  static readonly user = {
    getLoggedInUser: 'User/GetLoggedInUser'
  } as const;

  static readonly pbi = {
    embedInfo: '/PowerBI/EmbedInfo'
  } as const;

  static readonly dashboard = {
    getIntegrityOfficers: 'Dashboard/GetIntegrityOfficers',
    getReferenceDataCategories: 'Dashboard/GetReferenceDataCategories',
    getCoiForms: 'Dashboard/GetCoiForms',
    getDopiForms: 'Dashboard/GetDopiForms',
    getGbhForms: 'Dashboard/GetGbhForms',
  } as const;

  static readonly integrityOfficer = {
    getConfigAndResponse: 'IntegrityOfficer/GetResponseAndConfig',
    save: 'IntegrityOfficer/Save'
  } as const;

  static readonly referenceData = {
    getConfigAndResponse: 'ReferenceData/GetResponseAndConfig',
    save: 'ReferenceData/Save',
    bulkSave: 'ReferenceData/BulkSave',
  } as const;

  static readonly coiForm = {
    getConfigAndResponse: 'CoiForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'CoiForm/GetResponseAndConfigReadOnly',
    getConfigAndResponseExternal: 'CoiForm/GetResponseAndConfigExternal',
    getConfigAndResponseExternalReadOnly: 'CoiForm/GetResponseAndConfigExternalReadOnly',
    getConfigWithEmptyResponse: 'CoiForm/GetConfigWithEmptyResponse',
    exportToDataTables: 'CoiForm/ExportToDataTables',
    save: 'CoiForm/Save',
    saveExternal: 'CoiForm/SaveExternal',
    delete: 'CoiForm/Delete',
    downloadCopy: 'CoiForm/DownloadCopy',
    downloadCopyExternal: 'CoiForm/DownloadCopyExternal',
    downloadVersion: 'CoiForm/DownloadVersion',
    downloadVersionExternal: 'CoiForm/DownloadVersionExternal',
    reopenWithComment: 'CoiForm/ReopenWithComment',
    reopen: 'CoiForm/Reopen',
    requestFromExternalUser: 'CoiForm/RequestFromExternalUser'
  } as const;

  static readonly approverCoiForm = {
    getConfigAndResponse: 'ApproverCoiForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'ApproverCoiForm/GetResponseAndConfigReadOnly',
    save: 'ApproverCoiForm/SaveAsDraft',
    review: 'ApproverCoiForm/Review',
    approve: 'ApproverCoiForm/Approve',
    returnForAction: 'ApproverCoiForm/ReturnForAction',
    returnForActionWithoutAssessment: 'ApproverCoiForm/ReturnForActionWithoutAssessment'
  } as const;

  static readonly dopiForm = {
    getConfigAndResponse: 'DopiForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'DopiForm/GetResponseAndConfigReadOnly',
    getConfigAndResponseExternal: 'DopiForm/GetResponseAndConfigExternal',
    getConfigAndResponseExternalReadOnly: 'DopiForm/GetResponseAndConfigExternalReadOnly',
    getConfigWithEmptyResponse: 'DopiForm/GetConfigWithEmptyResponse',
    exportToDataTables: 'DopiForm/ExportToDataTables',
    save: 'DopiForm/Save',
    saveExternal: 'DopiForm/SaveExternal',
    delete: 'DopiForm/Delete',
    duplicate: 'DopiForm/Duplicate',
    downloadCopy: 'DopiForm/DownloadCopy',
    downloadCopyExternal: 'DopiForm/DownloadCopyExternal',
    downloadVersion: 'DopiForm/DownloadVersion',
    downloadVersionExternal: 'DopiForm/DownloadVersionExternal',
    requestFromExternalUser: 'DopiForm/RequestFromExternalUser'
  } as const;

  static readonly approverDopiForm = {
    getConfigAndResponse: 'ApproverDopiForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'ApproverDopiForm/GetResponseAndConfigReadOnly',
    save: 'ApproverDopiForm/SaveAsDraft',
    approve: 'ApproverDopiForm/Approve',
    returnForAction: 'ApproverDopiForm/ReturnForAction',
    returnForActionWithoutAssessment: 'ApproverDopiForm/ReturnForActionWithoutAssessment'
  } as const;

  static readonly gbhForm = {
    getConfigAndResponse: 'GbhForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'GbhForm/GetResponseAndConfigReadOnly',
    getConfigWithEmptyResponse: 'GbhForm/GetConfigWithEmptyResponse',
    exportToDataTables: 'GbhForm/ExportToDataTables',
    save: 'GbhForm/Save',
    delete: 'GbhForm/Delete',
    downloadCopy: 'GbhForm/DownloadCopy',
    downloadVersion: 'GbhForm/DownloadVersion'
  } as const;

  static readonly approverGbhForm = {
    getConfigAndResponse: 'ApproverGbhForm/GetResponseAndConfig',
    getConfigAndResponseReadOnly: 'ApproverGbhForm/GetResponseAndConfigReadOnly',
    save: 'ApproverGbhForm/SaveAsDraft',
    approve: 'ApproverGbhForm/Approve',
    returnForAction: 'ApproverGbhForm/ReturnForAction',
    returnForActionWithoutAssessment: 'ApproverGbhForm/ReturnForActionWithoutAssessment'
  } as const;
};

export const API_BASE_URLS_NOT_REQUIRING_SPINNER = [
  'api/User/GetCoiApprovers',
  'api/User/GetCoiApproversExceptLoggedInUser',
  'api/User/GetCoiInterestedParties',
  'api/User/GetCoiInterestedPartiesExceptLoggedInUser',
  'api/User/GetDopiApprovers',
  'api/User/GetDopiApproversExceptLoggedInUser',
  'api/User/GetGbhApproversExceptLoggedInUser'
];
